import { formatDate } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const lastSaleDate = ({ saleDate, ranCount }: SearchVehicle): string => {
    const countString = ranCount && +ranCount > 1 ? `(${ranCount}x)` : ''

    return `${formatDate(saleDate, { type: 'shortNumeric' }) || '—'} ${countString}`
}
